export default __webpack_public_path__ + "static/etcheverry-mindurry-2a97121da6251c34c29935202ddeda1c.jpg";